import { Inject, Injectable } from "@angular/core";
import { ReferrerService } from "@obg/ngx.global";
import { Request } from "express";

import { REQUEST_TOKEN } from "../model";

@Injectable()
export class ServerReferrerService implements ReferrerService {
	constructor(@Inject(REQUEST_TOKEN) private request: Request) {}

	getReferrer(): string {
		return (this.request.headers["Referer"] as string) || "";
	}
}
